import { formatTimestampHuman } from "../date-utils";
export const leadDtoFields = [{
        name: "name",
        title: "Nome",
        render: (record) => record.lead.name
    }, {
        name: "companyName",
        title: "Organizzazione"
    }, {
        name: "contactName",
        title: "Contatto"
    }, {
        name: "productName",
        title: "Prodotto"
    }, {
        name: "statusDescription",
        title: "Stato"
    }, {
        name: "sourceDescription",
        title: "Sorgente"
    }, {
        name: "outcome",
        title: "Esito",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            let icon = '';
            if (record.lead.closed === 1) {
                if (record.lead.success === 1) {
                    icon = 'check';
                }
                else if (record.lead.failure === 1) {
                    icon = 'close';
                }
            }
            return `<i class="material-icons">${icon}</i>`;
        }
    }, {
        name: "updatedBy",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        title: "Ultima Modifica"
    }, {
        name: "updatedOn",
        title: "Data Modifica",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.lead.updatedOn)
    }];
